import Cookies from 'js-cookie';
import {
  DEFAULT_EXPIRES_DAYS_COOKIES,
  KEY_AMOUNT_IN_URL,
  KEY_AUTH_TOKEN,
  KEY_FORENSICS_ACCESS_TOKEN,
  KEY_FORENSICS_SELFIE_UPLOADED,
  KEY_FORENSICS_TRANSACTION_ID,
  KEY_IS_EXPERIAN_REQUEST_EXIST,
  KEY_IS_SETU_ACCOUNT_SKIPPED,
  KEY_IS_SETU_SHARING_ABORT,
  KEY_IS_SETU_SHARING_SUCCESS,
  KEY_IS_USER_REGISTERED,
  KEY_PHONE_LOGIN,
  KEY_REFRESH_TOKEN,
  KEY_SAVE_INIT_VALUE_FORM,
  KEY_SETU_CONSENT_ID,
  KEY_USER_ID,
  KEY_RETRY_AFTER,
  SIGN_UP_OTP_CHECKER,
  KEY_IS_RETRY_AFTER_EXIST,
  KEY_IS_COUNTDOWN_WORKING,
} from 'const';

export const getStorageUserId = (): number => {
  if (getStorageAuthToken()) {
    return +(Cookies.get(KEY_USER_ID) || '0');
  }
  return 0;
};
export const setStorageUserId = (userId: number) =>
  Cookies.set(KEY_USER_ID, userId.toString(), {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageUserId = () => Cookies.remove(KEY_USER_ID);
export const removeSignUpOtpChecker = () => Cookies.remove(SIGN_UP_OTP_CHECKER);
export const removeTimerResendCode = () => {
  Cookies.remove('verification_attempts_confirmation_code');
  Cookies.remove('CORE_TIMER_KEY_resentCode');
};

export const getStorageAuthToken = (): string | null => Cookies.get(KEY_AUTH_TOKEN) || null;
export const setStorageAuthToken = (refreshToken: string) =>
  Cookies.set(KEY_AUTH_TOKEN, refreshToken, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageAuthToken = () => Cookies.remove(KEY_AUTH_TOKEN);

export const getStorageForensicsAccessToken = (): string | null =>
  Cookies.get(KEY_FORENSICS_ACCESS_TOKEN) || null;

export const getStorageForensicsSelfieUploaded = (): string | null =>
  Cookies.get(KEY_FORENSICS_SELFIE_UPLOADED) || null;

export const setStorageForensicsAccessToken = (accessToken: string) =>
  Cookies.set(KEY_FORENSICS_ACCESS_TOKEN, accessToken, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });

export const removeStorageForensicsAccessToken = () => Cookies.remove(KEY_FORENSICS_ACCESS_TOKEN);
export const removeStorageForensicsSelfieUploaded = () =>
  Cookies.remove(KEY_FORENSICS_SELFIE_UPLOADED);

export const getStorageForensicsTransactionId = (): string | null =>
  Cookies.get(KEY_FORENSICS_TRANSACTION_ID) || null;
export const setStorageForensicsTransactionId = (transactionId: string) =>
  Cookies.set(KEY_FORENSICS_TRANSACTION_ID, transactionId, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageForensicsTransactionId = () =>
  Cookies.remove(KEY_FORENSICS_TRANSACTION_ID);
export const getStorageSelfieRequest = (): string | null =>
  Cookies.get(KEY_FORENSICS_SELFIE_UPLOADED) || null;
export const setStorageSelfieRequest = (isSelfieUploaded: string) =>
  Cookies.set(KEY_FORENSICS_SELFIE_UPLOADED, isSelfieUploaded, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageSelfieRequest = () => Cookies.remove(KEY_FORENSICS_SELFIE_UPLOADED);

export const getStorageRefreshToken = (): string | null => Cookies.get(KEY_REFRESH_TOKEN) || null;
export const setStorageRefreshToken = (refreshToken: string) =>
  Cookies.set(KEY_REFRESH_TOKEN, refreshToken, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageRefreshToken = () => Cookies.remove(KEY_REFRESH_TOKEN);

export const getStorageIsUserRegistered = (): string | null =>
  Cookies.get(KEY_IS_USER_REGISTERED) || null;

export const setStorageIsUserRegistered = (isUserRegistered: string) =>
  Cookies.set(KEY_IS_USER_REGISTERED, isUserRegistered, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageIsUserRegistered = () => Cookies.remove(KEY_IS_USER_REGISTERED);

export const removeAllCookies = () =>
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });

export const getStoragePhoneLogin = (): string | null => {
  const statePhone = JSON.parse(sessionStorage.getItem(KEY_PHONE_LOGIN) || '{}');
  if (statePhone.phone && statePhone.date) {
    if (new Date(statePhone.date) > new Date()) {
      return statePhone.phone;
    }
  }
  return null;
};
export const setStoragePhoneLogin = (phone: string) =>
  sessionStorage.setItem(
    KEY_PHONE_LOGIN,
    JSON.stringify({
      phone,
      date: new Date(new Date().setMinutes(new Date().getMinutes() + 5)),
    })
  );
export const removeStoragePhoneLogin = () => sessionStorage.removeItem(KEY_PHONE_LOGIN);
export const removeStorageSaveInitValue = () => localStorage.removeItem(KEY_SAVE_INIT_VALUE_FORM);

export const getStorageIsSetuAccountSkipped = (): string | null =>
  Cookies.get(KEY_IS_SETU_ACCOUNT_SKIPPED) || null;
export const setStorageIsSetuAccountSkipped = (value: string) =>
  Cookies.set(KEY_IS_SETU_ACCOUNT_SKIPPED, value, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageIsSetuAccountSkipped = () => Cookies.remove(KEY_IS_SETU_ACCOUNT_SKIPPED);

export const getStorageIsExperianRequestExist = (): string | null =>
  Cookies.get(KEY_IS_EXPERIAN_REQUEST_EXIST) || null;

export const setStorageIsExperianRequestExist = (value: string) =>
  Cookies.set(KEY_IS_EXPERIAN_REQUEST_EXIST, value, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageIsExperianRequestExist = () =>
  Cookies.remove(KEY_IS_EXPERIAN_REQUEST_EXIST);

export const getStorageSetuConsentId = (): string | null =>
  Cookies.get(KEY_SETU_CONSENT_ID) || null;

export const setStorageSetuConsentId = (value: string) =>
  Cookies.set(KEY_SETU_CONSENT_ID, value, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageSetuConsentId = () => Cookies.remove(KEY_SETU_CONSENT_ID);

export const getStorageIsSetuSharingSuccess = (): string | null =>
  Cookies.get(KEY_IS_SETU_SHARING_SUCCESS) || null;

export const setStorageIsSetuSharingSuccess = (value: string) =>
  Cookies.set(KEY_IS_SETU_SHARING_SUCCESS, value, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });
export const removeStorageIsSetuSharingSuccess = () => Cookies.remove(KEY_IS_SETU_SHARING_SUCCESS);

export const getStorageIsSetuSharingAbort = (): string | null =>
  Cookies.get(KEY_IS_SETU_SHARING_ABORT) || null;

export const setStorageIsSetuSharingAbort = (value: string) =>
  Cookies.set(KEY_IS_SETU_SHARING_ABORT, value, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });

export const removeStorageIsSetuSharingAbort = () => Cookies.remove(KEY_IS_SETU_SHARING_ABORT);

export const removeStorageAmountParams = () => Cookies.remove(KEY_AMOUNT_IN_URL);
export const getStorageAmountParams = (): string | null => Cookies.get(KEY_AMOUNT_IN_URL) || null;
export const setStorageAmountParams = (value: string) =>
  Cookies.set(KEY_AMOUNT_IN_URL, value, {
    expires: DEFAULT_EXPIRES_DAYS_COOKIES,
    sameSite: 'Strict',
    secure: true,
  });

export const setStorageRetryAfter = (timerValue: string) =>
  Cookies.set(KEY_RETRY_AFTER, timerValue, {
    sameSite: 'Strict',
    secure: true,
  });

export const getStorageRetryAfter = (): string | null => Cookies.get(KEY_RETRY_AFTER) || null;

export const removeStorageRetryAfter = () => Cookies.remove(KEY_RETRY_AFTER);

export const setStorageIsCountdownWorking = (timerValue: string) =>
  Cookies.set(KEY_IS_COUNTDOWN_WORKING, timerValue, {
    sameSite: 'Strict',
    secure: true,
  });

export const getStorageIsCountdownWorking = (): string | null =>
  Cookies.get(KEY_IS_COUNTDOWN_WORKING) || null;

export const removeStorageIsCountdownWorking = () => Cookies.remove(KEY_IS_COUNTDOWN_WORKING);

export const setIsRetryAfterExist = (timerStatus: string) =>
  Cookies.set(KEY_IS_RETRY_AFTER_EXIST, timerStatus, {
    sameSite: 'Strict',
    secure: true,
  });

export const getIsRetryAfterExist = (): string | null =>
  Cookies.get(KEY_IS_RETRY_AFTER_EXIST) || null;

export const removeIsRetryAfterExist = () => Cookies.remove(KEY_IS_RETRY_AFTER_EXIST);
